import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faQuestion } from '@fortawesome/free-solid-svg-icons';
import Wallpaper from '../Wallpaper/Wallpaper';

const OptionsView = ({ screenObj, logButtonClick, setPage, setUserGUID, userGUID, json, userSelections, setUserSelections, scheduleSelection, setJson }) => {

    const [personalLinkType, setPersonalLinkType] = useState(localStorage.getItem('personalLinkType') ? localStorage.getItem('personalLinkType') : 'QR Code Option');
    const [personalUrl, setPersonalUrl] = useState(localStorage.getItem('personalUrl') ? localStorage.getItem('personalUrl') : '');
    const [personalFullUrl, setPersonalFullUrl] = useState('');
    const [placeholder, setPlaceholder] = useState('');

    useEffect(() => {
        setPlaceholder(() => {
            switch (personalLinkType) {
                case "URL":
                    return "URL (include http:// or https://)";
                case "Facebook":
                    return "Facebook Account Handle or ID";
                case "Instagram":
                    return "Instagram Account Handle";
                case "X":
                    return "X Account Handle";
                case "TikTok":
                    return "TikTok Account Handle";
                case "WhatsApp":
                    return "WhatsApp Account Handle";
                case "Email":
                    return "Email Address";
                case "Phone Number":
                    return "Alt. Phone: (###) ###-####";
                default:
                    return "";
            }
        });
    }, [personalLinkType]);

    useEffect(() => {
        setPersonalFullUrl(() => {
            switch (personalLinkType) {
                case "URL":
                    return `${personalUrl}`;
                case "Facebook":
                    return `https://facebook.com/${personalUrl}`;
                case "Instagram":
                    return `https://instagram.com/${personalUrl}`;
                case "X":
                    return `https://x.com/${personalUrl}`;
                case "TikTok":
                    return `https://www.tiktok.com/@${personalUrl}`;
                case "WhatsApp":
                    return `https://wa.me/${personalUrl.replace(/^\+|\D/g, (match, offset) => (offset === 0 && match === '+') ? '+' : '')}`;
                case "Email":
                    return `mailto:${personalUrl}`;
                case "Phone Number":
                    return `tel:${personalUrl.replace(/^\+|\D/g, (match, offset) => (offset === 0 && match === '+') ? '+' : '')}`;
                default:
                    return `${personalUrl}`;
            }
        });
    }, [personalLinkType, personalUrl]);

    useEffect(() => {
        localStorage.setItem('personalLinkType', personalLinkType)
    }, [personalLinkType]);

    useEffect(() => {
        localStorage.setItem('personalUrl', personalUrl)
    }, [personalUrl]);

    const closeOptionsView = () => {
        document.getElementById('destinationImages').innerHTML = '';
        setPage('calendar');
    }

    return (
        <div className="modal" style={{
            position: 'fixed',
            overflow: 'hidden',
            height: '100vh'
        }}>
            <div className="button-container">
                <button
                    onClick={() => setPage('help')}
                    style={{ flex: '1 0 48px' }}
                    className="btn">
                    <FontAwesomeIcon icon={faQuestion} /> Help
                </button>

                <button
                    onClick={closeOptionsView}
                    style={{ flex: '1 0 48px' }}
                    className="btn">
                    <FontAwesomeIcon icon={faTimes} /> Close
                </button>
            </div>
            <div className="input-container">
                <select
                    value={personalLinkType}
                    id="personalLinkType"
                    name="personalLinkType"
                    className={personalLinkType === 'QR Code Option' ? 'personal-link-type-unselected' : ''}
                    onChange={(e) => {
                        document.getElementById('destinationImages').innerHTML = '';
                        setPersonalLinkType(e.target.value)
                        setPersonalUrl('');
                    }}>
                    <option value="QR Code Option">{personalLinkType === 'QR Code Option' ? 'Select to add a personalized wallpaper QR Code' : 'None'}</option>
                    <option>Instagram</option>
                    <option>Facebook</option>
                    <option>X</option>
                    <option>TikTok</option>
                    <option>URL</option>
                    <option>WhatsApp</option>
                    <option>Email</option>
                    <option>Phone Number</option>
                </select>
                {personalLinkType !== 'QR Code Option' && <input
                    name="personalUrl"
                    id="personalUrl"
                    autoCapitalize="off"
                    autoComplete="off"
                    value={personalUrl}
                    placeholder={placeholder}
                    disabled={personalLinkType === 'QR Code Option'}
                    onChange={(e) => setPersonalUrl(e.target.value)}
                />}
            </div>

            <Wallpaper
                screenObj={screenObj}
                logButtonClick={logButtonClick}
                json={json}
                userSelections={userSelections}
                scheduleSelection={scheduleSelection}
                personalUrl={personalUrl}
                personalFullUrl={personalFullUrl}
            />

        </div>
    )
}

export default OptionsView;